import "./static/css/bootstrap.min.css";
import "antd/dist/antd.css";
import "./static/css/main.css";
import "./static/css/color_skins.css";
import "./static/css/custom.css";
import "./static/css/responsive.css";

import "popper.js";
import "jquery";
import "bootstrap/dist/js/bootstrap";

import React from "react";
import history from "./controller/History";
import {Router} from "react-router-dom";
import {Login} from "./pages/Login";
import {Dashboard} from "./pages/Dashboard";
import {WorkOrder} from "./pages/tracks/workorder/WorkOrderQuote";
import {PrivateRoute} from "./controller/PrivatePath";
import {PublicRoute} from "./controller/PublicPath";
import {Logout} from "./pages/Logout";
import {Main} from "./pages/Main";
import {Quotes} from "./pages/tracks/quotes/Quotes";
import {Routes} from "./pages/dispatch/routes/Routes";
import {Report} from "./pages/tracks/report/Report";
import {HotSheet} from "./pages/tracks/hotsheet/HotSheet"
import {DataManagement} from "./pages/tracks/data_management/DataManagement"
import {EmployeeProfile} from "./pages/analytics/employee_profile/EmployeeProfile"
import {LiveMap} from "./pages/dispatch/live_map/LiveMap"
import {AddTruck} from "./pages/analytics/add_truck/AddTruck"
import {Trash} from "./pages/tracks/trash/Trash";
import {Queue} from "./pages/dispatch/queue/Queue";
import {Draft} from "./pages/tracks/draft/Draft";
import {ProjectLog} from "./pages/crm/project_log/ProjectLog";
import {Proposal} from "./pages/crm/proposals/Proposal";
import {Generator} from "./pages/account/Generator";
import {BillTo} from "./pages/account/BillTo";
import {ClientProfile} from "./pages/crm/client_profile/ClientProfile";
import {WorkOrderPerformed} from "./pages/tracks/work_perform/work_order/WorkOrderPerformed";
import {HotsheetPerformed} from "./pages/tracks/work_perform/hotsheet_performed/HotsheetPerformed";
import {CallLog} from "./pages/ab-marketing/CallLog";
import {WasteProfile} from "./pages/tracks/waste_profile/WasteProfile";
import {InDevelopment} from "./pages/analytics/in_development/InDevelopment";
import {Layout} from "./pages/settings/Layout";

class App extends React.Component {

  render() {
    return (
      <div className="App">
        <Router history={history}>
          <div className="load-bg">
            <PublicRoute exact path="/" component={Login}/>
            <PrivateRoute exact path="/logout/" component={Logout}/>
            <Main>
              <PrivateRoute exact path="/dashboard/" component={Dashboard}/>
              <PrivateRoute exact path="/dashboard/work-order/" component={WorkOrder}/>
              <PrivateRoute exact path="/dashboard/quotes/" component={Quotes}/>
              <PrivateRoute exact path="/dashboard/routes/" component={Routes}/>
              <PrivateRoute exact path="/dashboard/queue/" component={Queue}/>
              <PrivateRoute exact path="/dashboard/report/" component={Report}/>
              <PrivateRoute exact path="/dashboard/hotsheet/" component={HotSheet}/>
              <PrivateRoute exact path="/dashboard/data-management/" component={DataManagement}/>
              <PrivateRoute exact path="/dashboard/employee-information/" component={EmployeeProfile}/>
              <PrivateRoute exact path="/dashboard/live-map/" component={LiveMap}/>
              <PrivateRoute exact path="/dashboard/trucks/" component={AddTruck}/>
              <PrivateRoute exact path="/dashboard/work-performed/" component={WorkOrderPerformed}/>
              <PrivateRoute exact path="/dashboard/manage-hotsheet/" component={HotsheetPerformed}/>
              <PrivateRoute exact path="/dashboard/proposals/" component={Proposal}/>
              <PrivateRoute exact path="/dashboard/trash/" component={Trash}/>
              <PrivateRoute exact path="/dashboard/draft/" component={Draft}/>
              <PrivateRoute exact path="/dashboard/project-log/" component={ProjectLog}/>
              <PrivateRoute exact path="/dashboard/client-profile/" component={ClientProfile}/>
              <PrivateRoute exact path="/dashboard/generator/" component={Generator}/>
              <PrivateRoute exact path="/dashboard/bill-to/" component={BillTo}/>
              <PrivateRoute exact path="/dashboard/marketing/call-log/" component={CallLog}/>
              <PrivateRoute exact path="/dashboard/waste-profiles/" component={WasteProfile}/>
              <PrivateRoute exact path="/dashboard/in-development/" component={InDevelopment}/>
              <PrivateRoute exact path="/dashboard/settings/" component={Layout}/>

            </Main>

          </div>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js